const ERROR_EVENT_TYPES = {
  application: 'uver:application:error',
  network: 'uver:network:error',
};

const formatErrorMessage = error => error?.message || String(error);

/**
 * Captures telemetry when a shared-nav API call returns an error.
 *
 * @param {Function} captureEvent - Function to capture telemetry event
 * @param {String} name - Name to report in telemetry as errorType
 * @param {'application'|'network'} type - Telemetry error category
 * @param {String|Error} error - Error message or Error object
 */
export default ({
  captureEvent,
  error,
  name,
  type,
}) => {
  if (!captureEvent) {
    console.warn('No function defined for captureEvent');
    return;
  }

  if (!error || !ERROR_EVENT_TYPES[type]) {
    return;
  }

  captureEvent(ERROR_EVENT_TYPES[type], {
    errorMessage: formatErrorMessage(error),
    errorType: name,
    severity: 'normal',
  });
};
